import { useEffect } from 'react';
import { TweenMax } from 'gsap';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/delta2/pc/');

export default function Comp() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta2portablepowerstation');
    const animB6 = getImageLocal(locale, ['cn']);
    const animB5 = getImageLocal(locale, ['kr']);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.animationB .items-box2',
            offset: 100, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '30%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const tweenA1 = TweenMax.fromTo(
            '.animationB .items-box2',
            0.3,
            {
                opacity: 0,
                ease: 'none',
            },
            {
                opacity: 1,
                ease: 'none',
            },
        );
        sceneA1.setTween(tweenA1);
        // @ts-ignore
        controllerDelta2?.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.animationB} animationB GtmModuleData-section`} data-section-id={css.animationB} data-section-title={t('delta2.aniB_box1_msg1')}>
            <div className="items-box">
                <div className="item-box item-box1">
                    <div className="item-box-img">
                        <EFPic name={['animB1.webp', 'animB1.jpg']} />
                    </div>
                    <div className="msg-box">
                        <div className="msg-line1">{t('delta2.aniB_box1_msg1')}</div>
                        <div className="msg-line2">{t('delta2.aniB_box1_msg2')}</div>
                    </div>
                </div>
                <div className="item-box item-box2">
                    <div className="item-box-img">
                        <EFPic name={['animB2.webp', 'animB2.jpg']} />
                    </div>
                    <div className="msg-box">
                        <div className="first-msg">{t('delta2.aniB_box2_msg1')}</div>
                        <div>
                            <div>{t('delta2.aniB_box2_msg2')}</div>
                            <div>{t('delta2.aniB_box2_msg3')}</div>
                        </div>
                    </div>
                </div>
                <div className="item-box item-box3">
                    <div className="item-box-img">
                        <EFPic name={['animB3.webp', 'animB3.jpg']} />
                    </div>
                    <div className="msg-box">
                        <div className="msg-line1">
                            {locale === 'kr' ? (
                                <>
                                    <span className="number">90%</span>
                                    <span className="text">{t('delta2.aniB_box3_msg1')}</span>
                                </>
                            ) : (
                                t('delta2.aniB_box3_msg1')
                            )}
                        </div>
                        <div className="msg-line2">{t('delta2.aniB_box3_msg2')}</div>
                        <div className="msg-line3">{t('delta2.aniB_box3_msg3')}</div>
                    </div>
                </div>
                <div className="item-box item-box4">
                    <div className="item-box-img">
                        <EFPic name={['animB4.webp', 'animB4.jpg']} />
                    </div>
                    <div className="msg-box">
                        <div className="msg-line1">{t('delta2.aniB_box4_msg1')}</div>
                        <div className="msg-line2">{t('delta2.aniB_box4_msg2')}</div>
                    </div>
                </div>
                <div className="item-box item-box5">
                    {!['au'].includes(locale) && (
                        <>
                            <div className="item-box-img">
                                <EFPic name={[`animB5_${animB5}.webp`, `animB5_${animB5}.jpg`]} />
                            </div>
                            <div className="msg-box">
                                <div className="msg-line1">{t('delta2.aniB_box5_msg1')}</div>
                            </div>
                        </>
                    )}
                    {['au'].includes(locale) && (
                        <>
                            <div className="left">
                                <div className="item-box-img">
                                    <EFPic name={[`animB5_1.webp`, `animB5_1.png`]} />
                                </div>
                                <div className="msg-box">
                                    <div className="msg-line1">{t('delta2.aniB_box5_msg1')}</div>
                                </div>
                            </div>
                            <div className="right">
                                <div className="item-box-img">
                                    <EFPic name={[`animB5_2.webp`, `animB5_2.png`]} />
                                </div>
                                <div className="msg-box">
                                    <div className="msg-line1">{t('delta2.aniB_box5_msg2')}</div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
                <div className="item-box item-box6">
                    <div className="item-box-img">
                        <EFPic name={[`animB6_${animB6}.webp`, `animB6_${animB6}.jpg`]} />
                    </div>
                    <div className="msg-box">
                        <div className="msg-line1">{t('delta2.aniB_box6_msg1')}</div>
                    </div>
                </div>
                <div className="item-box item-box7">
                    <div className="item-box-img">
                        <EFPic name={['animB7.webp', 'animB7.jpg']} />
                    </div>
                    <div className="msg-box">
                        <div className="msg-line1">{t('delta2.aniB_box7_msg1')}</div>
                        <div className="msg-line2">{t('delta2.aniB_box7_msg2')}</div>
                    </div>
                </div>
            </div>
            <div className="items-box2 title-bolder">
                <div className="msg-title1">{t('delta2.aniB_items_box2_msg1')}</div>
                <div className="msg-title2">{t('delta2.aniB_items_box2_msg2')}</div>
            </div>
        </div>
    );
}
